const routes = [
    {
        path: "/course/agreement/form-information/:token",
        component: () => import("../pages/Index"),
    }
]

export default routes;
